module.exports = __webpack_public_path__ + "b43cda7082ccd8d9a19b145048f915fb.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/image/Logo/LogoGF.png
// module id = 202
// module chunks = 0